var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_748_224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 9,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3534 0.854622C12.5485 0.659209 12.5486 0.342274 12.3536 0.146729C12.1587 -0.0488163 11.8425 -0.0489233 11.6474 0.14649L4.23135 7.57448C4.20112 7.59379 4.17251 7.61666 4.14613 7.64312C3.95505 7.8347 3.95139 8.14274 4.13499 8.33879C4.14121 8.34576 4.14765 8.35259 4.15433 8.35928C4.16008 8.36505 4.16593 8.37065 4.17188 8.37607L11.6473 15.8537C11.8425 16.0489 12.1589 16.0488 12.3539 15.8532C12.5489 15.6577 12.5487 15.3409 12.3535 15.1456L5.21472 8.00483L12.3534 0.854622Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_748_224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftOutlined);
export default __webpack_public_path__ + "static/media/chevron-left-outlined.60f24fd4e0f254a5bacae6718cf8223a.svg";
export { ForwardRef as ReactComponent };